export default {
    url: 'ocean-pro-home-solar-battery',
    include: ['us'],
};
